import { render, staticRenderFns } from "./LabsSession.vue?vue&type=template&id=6ec5b200&"
import script from "./LabsSession.vue?vue&type=script&lang=js&"
export * from "./LabsSession.vue?vue&type=script&lang=js&"
import style0 from "./LabsSession.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports